import { render, staticRenderFns } from "./customer-behavior-list.vue?vue&type=template&id=309e6f09&scoped=true"
import script from "./customer-behavior-list.vue?vue&type=script&lang=js"
export * from "./customer-behavior-list.vue?vue&type=script&lang=js"
import style0 from "./customer-behavior-list.vue?vue&type=style&index=0&id=309e6f09&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309e6f09",
  null
  
)

export default component.exports